// extracted by mini-css-extract-plugin
module.exports = {"RelatedItems":"RelatedItems_RelatedItems__8xhWO","titleDescription":"RelatedItems_titleDescription__fT-ul","header":"RelatedItems_header__20aAP"};